import { isActiveOrgTransaction } from '~/components/txn-display/state-change/utils/isActiveOrgTransaction'
import { IAddress, OrgTransaction, PublicTransaction } from '~/types'
import { EvmAddress } from '~/utils/address'
import { isVaultToken } from '~/utils/vault'

export const buildWatchAddresses = ({
  transaction,
  activeOrgId,
  orgAccountAddresses = [],
}: {
  transaction: OrgTransaction | PublicTransaction
  activeOrgId?: string
  orgAccountAddresses?: IAddress[]
}): EvmAddress.Type[] => {
  const addresses = new Set<EvmAddress.Type>([
    EvmAddress.format(transaction.smartAccountAddress),
  ])

  if (transaction.transactionRecipients) {
    transaction.transactionRecipients
      .filter((r) => EvmAddress.validate(r.recipientAddress))
      // Exclude vault contract addresses (e.g. Aave aUSDC) — they are DeFi
      // protocol intermediaries, not user-associated addresses.
      .filter((r) => !isVaultToken(transaction.chainId, r.recipientAddress))
      .forEach((recipient) => {
        addresses.add(EvmAddress.format(recipient.recipientAddress))
      })
  }

  // Funds can move between the org's own accounts without a recorded
  // recipient (automations, custom and Connect transactions), so watch every
  // org account. Only for the active org's transactions: other orgs' accounts
  // must never be added.
  if (isActiveOrgTransaction({ transaction, activeOrgId })) {
    orgAccountAddresses
      .filter((address) => EvmAddress.validate(address))
      .forEach((address) => {
        addresses.add(EvmAddress.format(address))
      })
  }

  return Array.from(addresses)
}
